import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faFolderOpen, faSquarePlus } from '@fortawesome/free-regular-svg-icons';
import { faBell, faCircle, faSquareMinus, faStar, faTriangleExclamation, faUserLock } from '@fortawesome/free-solid-svg-icons';
import { PropertyType } from '@hub4b/models/enums/property-type';
import { ColumnDefinition } from '@hub4b/models/server/column-definition';
import { LockedType } from '@hub4b/models/server/enums/locked-type';
import { Folder } from '@hub4b/models/server/folder';
import { AvmFolderCellPipe } from '@hub4b/pipes/avm-folder-cell.pipe';
import { AvmLinkPipe } from '@hub4b/pipes/avm-link.pipe';
import { AvmLockedByPipe } from '@hub4b/pipes/avm-locked-by.pipe';

@Component({
    selector: 'app-table-cell',
    templateUrl: './table-cell.component.html',
    styleUrls: ['./table-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, FaIconComponent, MatTooltipModule, DatePipe, AvmLinkPipe, AvmFolderCellPipe, AvmLockedByPipe]
})
export class TableCellComponent {
    /**
     * Références des icônes utilisés dans le template.
     */
    public lockByMeIcon = faFolderOpen;
    public lockByOtherIcon = faUserLock;
    public expandIcon = faSquarePlus;
    public collapseIcon = faSquareMinus;
    public unreadIcon = faCircle;
    public notificationIcon = faBell;
    public warningIcon = faTriangleExclamation;
    public isFollowedIcon = faStar;

    /** Déclaration des ENUM */
    public PropertyType = PropertyType;
    public LockedType = LockedType;

    @Input()
    public column: ColumnDefinition;

    /** Instance du dossier affiché sur cette ligne. */
    @Input()
    row: Folder;

    /** Indique si la ligne est dépliée. */
    @Input()
    isExpanded: boolean;

    /** Indique si la ligne de details contient les commentaires (true) ou les documents (false). */
    @Input()
    isExpandCommentsMode: boolean;

    /** Indique si la ligne de details contient les commentaires (true) ou les documents (false). */
    @Input()
    isFollowedFoldersList: boolean = false;

    @Output()
    expandOrCollapseRow: EventEmitter<Folder> = new EventEmitter<Folder>();

    constructor() {}

    /**
     * Emet un événement sur le clic de l'icone expand
     */
    public onExpandIconClick() {
        this.expandOrCollapseRow.emit(this.row);
    }
}
